import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * HAR handling for the Network tab. Worker-portable. The pack authors one
 * HAR per attempt (logs/<attempt>-network.har, registered in meta.yaml with
 * format: har). lambda-har-viewer consumes a plain HAR object shaped
 * {log: {pages: [], entries: []}} — kane's HAR 1.2 omits `pages`, so it is
 * defaulted here. Permissive: null on anything that isn't a HAR.
 */

function asRecord(v) {
  return v !== null && _typeof(v) === 'object' && !Array.isArray(v) ? v : null;
}

/** Parse + normalize HAR text. Null when it isn't a readable HAR document. */
export function parseHar(text) {
  var doc;
  try {
    doc = asRecord(JSON.parse(text));
  } catch (_unused) {
    return null;
  }
  var log = doc ? asRecord(doc.log) : null;
  if (!log || !Array.isArray(log.entries)) return null;
  return _objectSpread(_objectSpread({}, doc), {}, {
    log: _objectSpread(_objectSpread({}, log), {}, {
      pages: Array.isArray(log.pages) ? log.pages : []
    })
  });
}